import { motion } from "framer-motion";
import { Headphones, Globe, BellRing, CloudOff } from "lucide-react";
import { useSiteLang } from "../lib/siteLang";

const icons = [Headphones, Globe, BellRing, CloudOff];

export const Features = () => {
  const { t } = useSiteLang();

  return (
    <section id="features" className="section-padding bg-[#09101F]" data-testid="features-section">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <p className="section-label mb-4" data-testid="features-label">{t.featuresLabel}</p>
          <h2 className="text-3xl md:text-5xl text-white" style={{ textWrap: "balance" }} data-testid="features-title">
            {t.featuresTitle}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.features.map((feature, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={feature.title}
                initial={{ y: 24 }}
                whileInView={{ y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.07, ease: [0.16, 1, 0.3, 1] }}
                className="app-card inner-glow p-6 card-hover"
                data-testid={`feature-${index + 1}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#FF6B00]/15 border border-[#FF6B00]/30 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6 text-[#FF6B00]" aria-hidden="true" />
                </div>
                <h3 className="text-lg text-white mb-2">{feature.title}</h3>
                <p className="text-sm" style={{ color: "rgba(255,255,255,0.72)" }}>{feature.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
